module.exports = __webpack_public_path__ + "img/CloudPenetration.6d3f4edc.jpg";